<template>
    <div class="printSetBox clearfix">
        <div class="left">
            <div class="lawEditBox">
                <section class="gradeSection">
                    <div class="path">
                        <span class="title">榉木码单导入</span>
                        <div class="">
                            <i class="el-icon-refresh" @click="getList(1)"></i>
                        </div>
                    </div>
                    <div class="table_path">
                        <div class="dragTable">
                            <div :class="['dragThead', isScroll ? 'thGlutter' : '', 'clearfix']">
                                <div class="th">字段名称</div>
                                <div class="th">拖动列表</div>
                                </div>
                                <div class="dragTbody" id="dragTbody" ref="dragTbody">
                                <div
                                    class="dragTbodyTr clearfix"
                                    @dragstart="dragstart($event, item, index)"
                                    @dragend="dragend($event, item, index)"
                                    @dragenter="dragenter($event, item, index)"
                                    @dragleave="dragleave($event)"
                                    @dragover="dragover($event)"
                                    @drop="dragdrop($event)"
                                    :draggable="true"
                                    v-for="(item, index) in list"
                                    :key="'drag' + index"
                                >
                                    <div class="td">{{ item.name }}</div>
                                    <div class="td">
                                    <div class="clearfix sort">
                                        <div class="sortBack"></div>
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- <el-table :data="list" style="width: 100%" height="100%" size="mini" header-cell-class-name="list_table_th text-center">
                            <el-table-column label="字段名称" prop="name" show-overflow-tooltip></el-table-column>
                            <el-table-column label="顺序排列" width="100">
                                <template slot-scope="scope">
                                    <div class="lawup" @click="changeStatus(scope.row,'up',scope.$index)"></div>
                                    <div class="lawdown" @click="changeStatus(scope.row,'down',scope.$index)"></div>
                                </template>
                            </el-table-column>
                        </el-table> -->
                    </div>
                </section>
            </div>
        </div>
    </div>
</template>
<style scoped lang="scss">
    .dragTable {
        width: 100%;
        position: relative;
        padding-top: 30px;
        height: 100%;
        box-sizing: border-box;
        flex: 1;
        overflow: hidden;
    }

    .dragTable >>> .dragHover {
        background-color: #b1d2a8 !important;
    }
    .dragThead {
        width: 100%;
        height: 30px;
        position: absolute;
        top: 0;
        left: 0;
        border-left: 1px solid #ccc;
        border-top: 1px solid #ccc;
        box-sizing: border-box;
        }
    .dragTbody {
        height: 100%;
        overflow: auto;
    }
    .dragThead .th{
        width: 50%;
        float: left;
        line-height: 30px;
        background-color: #ebe8e8;
        color: #000;
        font-size: 12px;
        border: 1px solid #ccc;
        box-sizing: border-box;
        border-top: 0;
        border-left: 0;
        text-align: center;
    }
    .dragTbody .td {
        width: 50%;
        float: left;
        font-size: 12px;
        line-height: 30px;
        min-height: 30px;
        border: 1px solid #ccc;
        box-sizing: border-box;
        border-top: 0;
        border-right: 0;
        text-align: center;
    }
    .dragThead .th.first {
        width: 12%;
    }
    .dragTbody .td.first {
        width: 12%;
    }
    .dragTbody .td.last{
        border-right: 1px solid #ccc;
    }
    .dragTbody .sort {
        height: 30px;
        text-align: center;
        padding: 0 15px;
    }
    .sortBack{
        cursor: pointer;
        width: 20px;
        height: 20px;
        margin: auto;
        background: url(/icon/drag_dark.png) no-repeat content-box center ;
        background-size: contain;
        position: relative;
        top: 6px;
    }
    .sortBack:hover{
        background-image: url(/icon/drag_light.png);
    }
    .lawEditBox{height:100%;display: flex;flex-direction: column;overflow: hidden;width:100%;}
    .gradeSection{display: flex;flex-direction: column;height:100%;flex: 1;overflow: hidden;}
    .titlelaw{font-size: 13px;font-weight: 700;color:#333;margin-bottom:10px;}
    .lawup{width:15px;height:15px;background: url(/icon/lawup.png) no-repeat 100% 100%;background-size: 100% 100%;cursor: pointer;float: left;margin-right:10px;}
    .lawdown{width:15px;height:15px;background: url(/icon/lawdown.png) no-repeat 100% 100%;background-size: 100% 100%;cursor: pointer;float: left;}
    .eldialogA .dialogBtnList{padding-right:0;}
    .path_title{text-align: left;
        font-size:16px; font-weight:bold; margin-top: 26px;margin-bottom:20px;
        & + div{ margin-bottom: 20px; color: #333333; display: flex; align-items: center; }
    }
    .input_box{ width:80px; margin: 0 10px; }
    .container{
        padding: 34px 30px; display: flex; flex-direction: column; align-items: stretch; text-align: left; height: 100%; background-color: #fff; border-top:8px solid #EEEFF2; border-left:12px solid #EEEFF2;
    }
    .path_switch{text-align: left;margin-bottom:20px;}
    .path{
            margin-bottom: 7px; display: flex; align-items: center; justify-content: space-between;
            .title{
                font-size:16px; font-weight:bold; color: #333333; border-left:4px solid #b21111; padding-left: 12px;
            }
        }
    .table_path{ flex: 1; box-shadow:0px 0px 10px rgba(94,94,94,0.16); border-radius:3px; width: 100%; display: flex;height: 90%;}
    .el-icon-refresh{margin-right:10px;cursor: pointer;color:#F9A602;font-weight: 600;}
    .tab{
        display: flex; align-items: center; font-size:16px; color:rgba(51,51,51,1);
        .item{
            border-bottom: 3px solid transparent; padding:4px; cursor: pointer;
            &.active{ border-color: #B21111}
        }
        .item + .item{ margin-left: 75px}
    }
    .flex_1{ flex: 1; }
    .printSetBox{box-sizing: border-box;position: relative;display: flex;flex-direction: column;width:340px;flex:1;height: 100%;overflow: hidden;}
    .blue{ color: rgb(21, 91, 212); cursor: pointer; }
    .left{flex: 1;height:100%;overflow: hidden;display: flex;margin-top:10px;}
    // F6F7FB
</style>
<script>
    export default {
        data(){
            return{
                companyName:localStorage.dw_erp_company_name,
                list:[],
                moveRow: {},
                isScroll: false,
            }
        },
        created(){
            this.getList()
        },
        methods:{
            togDragClass(enter=false) {
                let c = "dragTbodyTr clearfix";
                if (enter ===true) {
                    c = "dragTbodyTr clearfix dragHover";
                }
                return c;
            },
            dragenter(e, row, indexNumber) {
                e.currentTarget.classList = this.togDragClass(true);
                let list = JSON.parse(JSON.stringify(this.list));
                if (indexNumber < list.length - 1) {
                    list.forEach((item, index) => {
                    if (item.isMove) {
                        list.splice(index, 1);
                    }
                });
                list.splice(indexNumber, 0, this.moveRow);
                }
                this.list = list;
                e.preventDefault();
            },
            dragend(e, row) {
                if (this.originalList.length == this.list.length) {
                    let list = JSON.parse(JSON.stringify(this.list));
                    list.forEach((item, index) => {
                        if (this.moveRow.field == item.field) {
                            if (!item.isMove) {
                                // list.splice(index, 1);
                            } else {
                                item.isMove = false;
                            }
                        }
                    });
                    for(let i = 0; i < list.length; i++) {
                        list[i].sort = i + 1;
                    }
                    this.list = list;
                    this.postFunc("/erp/excel.set.update",{column:this.list,category:10},()=>{
                        this.getList()
                        this.tip("移动成功","success")
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                } else {
                    this.list = JSON.parse(JSON.stringify(this.originalList));
                }
                this.moveRow = {};
            },
            dragstart(e, row) {
                row.isMove = true;
                this.moveRow = JSON.parse(JSON.stringify(row));
            },
            dragover(e) {
                e.preventDefault();
            },
            dragdrop(e) {
                e.currentTarget.classList = this.togDragClass(false);
            },
            dragleave(e) {
                e.currentTarget.classList = this.togDragClass(false);
            },
            changeStatus(row,direction,index){
                let list = JSON.parse(JSON.stringify(this.list))
                if(direction == "down"){
                    if(index<list.length-2){
                        var item = JSON.parse(JSON.stringify(list[index]));
                        list[index] = list[index+1];
                        list[index+1] = item;
                    }
                }else if(direction == "up"){
                    if(index>0){
                        var item = JSON.parse(JSON.stringify(list[index]));
                        list[index] = list[index-1];
                        list[index-1] = item;
                    }
                }
                for(let i=0;i<list.length;i++){
                    list[i].sort = i+1;
                }
                this.list = list;
                this.postFunc("/erp/excel.set.update",{column:this.list,category:10},()=>{
                    this.getList()
                    if(direction == "up"){
                        this.tip("上移成功","success")
                    }else{
                        this.tip("下移成功","success")
                    }
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getList(showMessage){
                this.postFunc("/erp/excel.set.get",{"category": 10},res=>{
                    this.list = res.data.data.column;
                    if(showMessage){
                        this.tip("刷新成功","success")
                    }
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            }
        },
        watch:{
            list:function(val){
                this.originalList = val;
            }
        }
    }
</script>
